var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSwapHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8884 58.82C43.3501 58.82 42.8118 58.6217 42.3868 58.1967C41.5651 57.375 41.5651 56.015 42.3868 55.1933L56.5818 40.9983C57.4034 40.1767 58.7634 40.1767 59.5851 40.9983C60.4068 41.82 60.4068 43.18 59.5851 44.0017L45.3901 58.1967C44.9651 58.5933 44.4268 58.82 43.8884 58.82Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0834 44.5967H9.91675C8.75508 44.5967 7.79175 43.6333 7.79175 42.4717C7.79175 41.31 8.75508 40.3467 9.91675 40.3467H58.0834C59.2451 40.3467 60.2084 41.31 60.2084 42.4717C60.2084 43.6333 59.2451 44.5967 58.0834 44.5967Z",
    fill: "#5F5F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91674 27.6532C9.37841 27.6532 8.84008 27.4549 8.41508 27.0299C7.59341 26.2083 7.59341 24.8482 8.41508 24.0266L22.6101 9.83158C23.4317 9.00992 24.7917 9.00992 25.6134 9.83158C26.4351 10.6532 26.4351 12.0132 25.6134 12.8349L11.4184 27.0299C11.0217 27.4266 10.4551 27.6532 9.91674 27.6532Z",
    fill: "#5F5F5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0834 27.6533H9.91675C8.75508 27.6533 7.79175 26.69 7.79175 25.5283C7.79175 24.3667 8.75508 23.4033 9.91675 23.4033H58.0834C59.2451 23.4033 60.2084 24.3667 60.2084 25.5283C60.2084 26.69 59.2451 27.6533 58.0834 27.6533Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwapHorizontal);
export default __webpack_public_path__ + "static/media/arrow-swap-horizontal.2f54e6aa4f8ca775d4322d7f3884f49a.svg";
export { ForwardRef as ReactComponent };